import { TabProps } from "@mantine/core";

import { CurrentUser } from "../../types/user.ts";
import { isBababosTenant } from "../../utils/user.ts";

interface Tab extends TabProps {
  label: string;
  hidden?: boolean;
}

export enum TabValue {
  OdooContactData = "odooContactData",
  Invoices = "invoices",
  CollectionActivity = "collectionActivity",
  CollectionDocument = "collectionDocument",
  Restructure = "restructure",
  Waive = "waive",
  LateFee = "lateFee",
  Giro = "giro",
  Transactions = "transactions",
}

export const getTabs = (user: CurrentUser | null | undefined): Tab[] => {
  const tabs = [
    {
      value: TabValue.OdooContactData,
      label: "Contact Data",
    },
    {
      value: TabValue.Invoices,
      label: "Invoices",
    },
    {
      value: TabValue.CollectionActivity,
      label: "Collection activity",
    },
    {
      value: TabValue.CollectionDocument,
      label: "Collection document",
      hidden: !isBababosTenant(user),
    },
    {
      value: TabValue.Restructure,
      label: "Restructure",
    },
    {
      value: TabValue.Waive,
      label: "Waive",
    },
    {
      value: TabValue.LateFee,
      label: "Late Fee",
    },
    {
      value: TabValue.Giro,
      label: "GIRO List",
      hidden: !isBababosTenant(user),
    },
    {
      value: TabValue.Transactions,
      label: "Transaction History",
      hidden: !isBababosTenant(user),
    },
  ];
  return tabs.filter((tab) => !tab.hidden);
};
